import { gql } from '@apollo/client';

export const CREATE_TT_BAG = gql`
    mutation CreateTTBag($input: CreateTTBagInput!) {
        result: createTTBag(input: $input) {
            bags {
                id
                bagNumber
                bagType
                businessType
                warehouseId
                sortingCode
                fromLocation
                toLocation
                nextStop
                carrierCode
                status
                createdAt
            }
            successCount
            errorMessage
        }
    }
`;

export interface CreateTTBagInput {
    /** TT Sort：由 getDefaultTtFromCode 映射；Temu Sort 可传 TEMU */
    from?: string;
    to?: string;
    nextStop: string;
    sortingCode?: string;
    warehouseId: string;
    businessType: number;
    copyNum: number;
    carrierCode?: number;
    lengthCm?: number;
    widthCm?: number;
    heightCm?: number;
    weightKg?: number;
    sortingInfo?: string;
}

export interface TTBag {
    id: string;
    bagNumber: string;
    bagType: number;
    businessType?: number;
    warehouseId: string;
    sortingCode: string;
    fromLocation?: string;
    toLocation?: string;
    nextStop?: string;
    carrierCode?: number;
    status: number;
    createdAt: string;
}

export interface CreateTTBagResult {
    bags: TTBag[];
    successCount: number;
    errorMessage?: string;
}

export interface CreateTTBagResponse {
    result: CreateTTBagResult;
}
